import * as z from "zod";

export const formSchema = z.object({
  fullName: z.string().min(1, "Full name filed is required."),
  contactNumber: z.string().min(1, "Phone filed is required."),
  email: z.email().min(1, "Email id filed is required."),
  message: z.string().optional(),
  serviceId: z.any().optional(),
  teamSize: z.string().optional(),
  whoAreWe: z.string().optional(),
  enquiryType: z.string().optional(),
  preferredOption: z.string().optional(),
  requestDate: z.date().optional(),
  requestTime: z.string().optional(),
  jobTitle: z.string().optional(),
  companyName: z.string().optional(),
  country_id: z.string().optional(),
  requirementType: z.string().optional(),
  interested: z.string().optional(),
  noOfParticipants: z.string().optional(),
  filePath: z
    .union([z.instanceof(File), z.string()])
    .nullable()
    .optional(),
  countryName: z.string().optional(),
  cityName: z.string().optional(),
  linkedIn: z.string().optional(),
  certificatePath: z
    .union([z.instanceof(File), z.string()])
    .nullable()
    .optional(),
  experience: z.string().optional(),
  serviceResourceId: z.number().optional(),
  terms: z.boolean(),
});

export type FormSchemaType = z.infer<typeof formSchema>;
